import request from '@/config/axios'
import type { PageParam } from '@/types/common'

/**
 * 域名类型枚举
 */
export enum DomainTypeEnum {
  H5 = 1,       // H5域名
  MINI_APP = 2,  // 小程序AppID
  APP = 3,       // App包名
  ADMIN = 4      // 管理后台域名
}

/**
 * 租户域名 VO
 */
export interface TenantDomainVO {
  id?: number
  tenantId: number
  domain: string
  domainType: number
  moduleCode?: string
  /** 可选：域名显式绑定公众号（一号多域：多条域名绑同一号） */
  mpAccountId?: number
  isDefault?: boolean
  status: number
  createTime?: Date
}

/**
 * 租户域名分页查询
 */
export const getTenantDomainPage = (params: PageParam & { tenantId?: number; domain?: string; domainType?: number; status?: number }) => {
  return request.get({ url: '/system/tenant-domain/page', params })
}

/**
 * 获取租户域名详情
 */
export const getTenantDomain = (id: number): Promise<TenantDomainVO> => {
  return request.get({ url: '/system/tenant-domain/get?id=' + id })
}

/**
 * 创建租户域名绑定
 */
export const createTenantDomain = (data: TenantDomainVO) => {
  return request.post({ url: '/system/tenant-domain/create', data })
}

/**
 * 更新租户域名绑定
 */
export const updateTenantDomain = (data: TenantDomainVO) => {
  return request.put({ url: '/system/tenant-domain/update', data })
}

/**
 * 删除租户域名绑定
 */
export const deleteTenantDomain = (id: number) => {
  return request.delete({ url: '/system/tenant-domain/delete?id=' + id })
}

/**
 * 根据租户ID获取域名绑定列表
 */
export const getTenantDomainListByTenantId = (tenantId: number): Promise<TenantDomainVO[]> => {
  return request.get({ url: '/system/tenant-domain/list-by-tenant', params: { tenantId } })
}
